var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDealerLocatorLocationSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,0C9.3828125,0,4,5.3833008,4,12c0,3.8833008,2.9150391,8.6748047,4.1679688,10.5546875l5.4453125,8.1679688 C14.1464844,31.5224609,15.0390625,32,16,32s1.8535156-0.4775391,2.3867188-1.2773438l5.4453125-8.1679688 C25.0849609,20.6748047,28,15.8833008,28,12C28,5.3833008,22.6171875,0,16,0z M22.1679688,21.4453125l-5.4453125,8.1679688 c-0.3222656,0.484375-1.1230469,0.484375-1.4453125,0l-5.4453125-8.1679688C7.4326172,17.8461914,6,14.3149414,6,12 C6,6.4858398,10.4863281,2,16,2s10,4.4858398,10,10C26,14.3149414,24.5673828,17.8461914,22.1679688,21.4453125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,7c-2.7568359,0-5,2.2431641-5,5s2.2431641,5,5,5s5-2.2431641,5-5S18.7568359,7,16,7z M16,15 c-1.6542969,0-3-1.3457031-3-3s1.3457031-3,3-3s3,1.3457031,3,3S17.6542969,15,16,15z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealerLocatorLocationSmall);
export default __webpack_public_path__ + "static/media/dealer-locator-location--small.dc91e87414c17c670ee3ead15201e383.svg";
export { ForwardRef as ReactComponent };